module.exports = __webpack_public_path__ + "static/media/NoNetwork.0c40a0e1.svg";